var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group position-relative" }, [
    _c("label", { staticClass: "font-size-12" }, [_vm._v(_vm._s(_vm.label))]),
    (_vm.unit === "px" && _vm.valueType === "integer" ? "text" : "number") ===
    "checkbox"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.iValue,
              expression: "iValue",
            },
          ],
          ref: "inputValue",
          staticClass: "form-control",
          style: { paddingRight: "25px" },
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            type: "checkbox",
          },
          domProps: {
            checked: Array.isArray(_vm.iValue)
              ? _vm._i(_vm.iValue, null) > -1
              : _vm.iValue,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.iValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.iValue = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.iValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.iValue = $$c
              }
            },
          },
        })
      : (_vm.unit === "px" && _vm.valueType === "integer"
          ? "text"
          : "number") === "radio"
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.iValue,
              expression: "iValue",
            },
          ],
          ref: "inputValue",
          staticClass: "form-control",
          style: { paddingRight: "25px" },
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            type: "radio",
          },
          domProps: { checked: _vm._q(_vm.iValue, null) },
          on: {
            change: function ($event) {
              _vm.iValue = null
            },
          },
        })
      : _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.iValue,
              expression: "iValue",
            },
          ],
          ref: "inputValue",
          staticClass: "form-control",
          style: { paddingRight: "25px" },
          attrs: {
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            type:
              _vm.unit === "px" && _vm.valueType === "integer"
                ? "text"
                : "number",
          },
          domProps: { value: _vm.iValue },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.iValue = $event.target.value
            },
          },
        }),
    _c(
      "span",
      {
        staticClass: "unit position-absolute",
        style: { top: "36px", right: "8px" },
      },
      [_vm._v(_vm._s(_vm.unit))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }